
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M-4-4h32v32H-4z"}}),_c('path',{attrs:{"d":"M12 23.625c2.094 0 4.031-.523 5.812-1.57a11.747 11.747 0 004.243-4.242A11.269 11.269 0 0023.625 12c0-2.094-.523-4.031-1.57-5.812a11.747 11.747 0 00-4.243-4.243A11.269 11.269 0 0012 .375c-2.094 0-4.031.523-5.813 1.57a11.747 11.747 0 00-4.242 4.243A11.269 11.269 0 00.375 12c0 2.094.523 4.031 1.57 5.813a11.747 11.747 0 004.242 4.242A11.269 11.269 0 0012 23.625zm8.625-6.328a3.466 3.466 0 00-1.219-1.547 3.41 3.41 0 00-1.453-.75l-1.5-.469C17.484 13.406 18 12.063 18 10.5a5.95 5.95 0 00-.797-3.023 5.837 5.837 0 00-2.18-2.18A5.95 5.95 0 0012 4.5a5.95 5.95 0 00-3.023.797 5.837 5.837 0 00-2.18 2.18A5.95 5.95 0 006 10.5c0 1.563.516 2.906 1.547 4.031l-1.5.469c-.5.125-.985.375-1.453.75a3.466 3.466 0 00-1.219 1.547A9.92 9.92 0 011.875 12c0-1.844.453-3.539 1.36-5.086a10.133 10.133 0 013.679-3.68C8.461 2.328 10.156 1.875 12 1.875c1.844 0 3.539.453 5.086 1.36a10.133 10.133 0 013.68 3.68c.906 1.546 1.359 3.241 1.359 5.085a9.92 9.92 0 01-1.5 5.297zM12 15c-1.25 0-2.313-.437-3.188-1.312S7.5 11.75 7.5 10.5c0-1.25.437-2.312 1.312-3.187S10.75 6 12 6c1.25 0 2.312.438 3.187 1.313S16.5 9.25 16.5 10.5c0 1.25-.438 2.313-1.313 3.188S13.25 15 12 15zm0 7.125c-1.469 0-2.852-.29-4.148-.867A9.668 9.668 0 014.5 18.797a2.528 2.528 0 01.586-1.5 2.67 2.67 0 011.336-.89L9 15.702a5.824 5.824 0 003 .797 5.824 5.824 0 003-.797l2.578.703a2.67 2.67 0 011.336.89c.36.438.555.938.586 1.5a9.668 9.668 0 01-3.352 2.462c-1.296.578-2.68.867-4.148.867z","fill":"currentColor"}})])])
          )
        }
      }
    